import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import InvoiceTypeModal from "./InvoiceTypeModal"
import ActionButton from "./ActionButton"

const InvoiceBanner = ({ standardInvoicing }) => {
  const [modalOpen, setModalOpen] = useState(false)
  if (!standardInvoicing?.can_create) return null

  return (
    <div className="px-7 mt-4">
      <div className="bg-slate-50 border border-dashed border-slate-300 rounded-xl px-4 py-3 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 grid place-items-center rounded-full bg-blue-50 text-blue-700">
            <FontAwesomeIcon icon="file-invoice" />
          </span>
          <div className="flex flex-col">
            <span className="text-[13px] font-semibold text-slate-900">
              {I18n.t("projects.invoices.banner.empty_title")}
            </span>
            <span className="text-[11.5px] text-slate-500">
              {I18n.t("projects.invoices.banner.empty_hint")}
            </span>
          </div>
        </div>
        <div className="ml-auto">
          <ActionButton onClick={() => setModalOpen(true)}>
            {I18n.t("projects.invoices.banner.cta")}
          </ActionButton>
        </div>
      </div>

      <InvoiceTypeModal
        isOpen            = {modalOpen}
        standardInvoicing = {standardInvoicing}
        onClose           = {() => setModalOpen(false)}
      />
    </div>
  )
}

export default InvoiceBanner
